/** Shared formatting helpers, matching the original js/ui.js helpers. */

/**
 * Money, in Kenyan shillings.
 *
 * Matches money() in the original js/financials.js: the currency is prefixed
 * and the locale is pinned, so a figure reads the same for every user rather
 * than depending on their browser's region settings. Whole amounts drop the
 * decimals; anything fractional keeps two.
 *
 * The space between the currency and the figure is a non-breaking one, so a
 * narrow card can wrap after "Paid" but never splits "KSh 2,400,000" into
 * two lines.
 */
export function money(value) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const opts = n % 1 === 0
    ? { maximumFractionDigits: 0 }
    : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  return `KSh\u00A0${n.toLocaleString('en-US', opts)}`;
}

export function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function percent(value) {
  const n = Number(value);
  return Number.isFinite(n) ? `${Math.round(n)}%` : '—';
}

/** The roles profiles.role can hold, and how each is written for a person. */
const ROLE_LABEL = {
  client: 'Client',
  project_manager: 'Project Manager',
  site_agent: 'Site Agent',
  administrator: 'Administrator',
};

export function roleLabel(role) {
  return ROLE_LABEL[role] ?? role ?? '—';
}
